import { htmlToPlaintext } from '../util/html.js';
import { cappedText } from '../util/text.js';
import { InteractionType } from './index.js';
const bodyOf = (i) => {
    const d = i.details;
    if (!d) {
        return '';
    }
    switch (i.type) {
        case InteractionType.Email: {
            const body = typeof d.body === 'string' ? d.body : '';
            if (body) {
                return body;
            }
            const html = typeof d.html === 'string' ? d.html : '';
            return htmlToPlaintext(html);
        }
        case InteractionType.SMS:
            return typeof d.text === 'string' ? d.text : '';
        case InteractionType.Letter:
            return typeof d.body === 'string' ? d.body : '';
        case InteractionType.Eboks:
        case InteractionType.Kivra:
        case InteractionType.Digipost:
            return typeof d.body === 'string' ? d.body : '';
        case InteractionType.AutoCall:
            return typeof d.transcript === 'string' ? d.transcript : '';
        case InteractionType.Note:
        case InteractionType.ClientNote:
        case InteractionType.DebtorNote:
        case InteractionType.Personal:
        case InteractionType.Other:
            return i.notes ?? '';
        case InteractionType.Phone:
        case InteractionType.EInvoice:
            return '';
        default:
            return '';
    }
};
const subjectOf = (i) => {
    const d = i.details;
    if (!d) {
        return null;
    }
    switch (i.type) {
        case InteractionType.Email:
            return typeof d.subject === 'string' ? d.subject : null;
        case InteractionType.Eboks:
        case InteractionType.Kivra:
        case InteractionType.Digipost:
            return typeof d.title === 'string' ? d.title : null;
        default:
            return null;
    }
};
const stringify = (v) => {
    if (v == null) {
        return null;
    }
    if (typeof v === 'string') {
        return v;
    }
    if (typeof v === 'object') {
        const o = v;
        if (typeof o.number === 'string') {
            return o.number;
        }
        return null;
    }
    return null;
};
const fromOf = (i) => {
    const d = i.details;
    if (!d) {
        return null;
    }
    switch (i.type) {
        case InteractionType.Email:
            return typeof d.from === 'string' ? d.from : null;
        case InteractionType.SMS:
            return typeof d.from === 'string' ? d.from : null;
        case InteractionType.AutoCall:
            return typeof d.fromPhoneNumber === 'string' ? d.fromPhoneNumber : null;
        case InteractionType.Phone:
            return stringify(d.phone);
        default:
            return null;
    }
};
const toOf = (i) => {
    const d = i.details;
    if (!d) {
        return null;
    }
    switch (i.type) {
        case InteractionType.Email:
            return typeof d.to === 'string' ? d.to : null;
        case InteractionType.SMS:
            return typeof d.number === 'string' ? d.number : null;
        case InteractionType.AutoCall:
            return typeof d.toPhoneNumber === 'string' ? d.toPhoneNumber : null;
        case InteractionType.Letter: {
            const a = d.address;
            if (!a) {
                return null;
            }
            const parts = [a.street, a.zipCode, a.city].filter((p) => typeof p === 'string');
            return parts.length > 0 ? parts.join(', ') : null;
        }
        default:
            return null;
    }
};
export const interactionSnippet = (i) => cappedText(bodyOf(i), 200);
export const interactionBody = (i) => bodyOf(i);
export const interactionSubject = subjectOf;
export const interactionFrom = fromOf;
export const interactionTo = toOf;
//# sourceMappingURL=extract.js.map